<template>
    <div :style="{ width: sizeWidth + 'px', height: sizeHeight + 'px' }" :class="classesFather">
        <b-img :src="url" fluid :alt="altText ? altText : ''" :class="classes" />
    </div>
</template>

<script>
    export default {
        name: 'SimpleImage',
        props: {
            url: {
                type: String,
                required: true
            },
            altText: String,           
            classes: String,
            classesFather: String,
            sizeWidth: {
                type: String,
                required: true
            },
            sizeHeight: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    div {
        text-align: center;
        img {
            max-height: 100%;
        }
    }
</style>